import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunk-24IY7LWP.mjs";
import "./chunk-NGNAAXSQ.mjs";
export {
  ArchitectureModule,
  createArchitectureServices
};
